import React, { useState } from 'react';
import Wrapper from '../../components/Wrapper';
import { Button, Form, InputGroup, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSample } from '../../store/features/sampleSlice';
import UpdateForm from '../../components/Forms/UpdateForm';

const UpdateReport = () => {
  const dispatch = useDispatch();
  const [searchKeyword, setSearchKeyword] = useState('');
  const { status, error, sample } = useSelector((state) => state.sample);

  const handleSearch = (e) => {
    if (e.type === 'click' || e.key === 'Enter') {
      dispatch(fetchSample({ searchKeyword }));
    }
  };
  return (
    <Wrapper>
      <div className='d-flex flex-column justify-content-center align-items-center pt-4'>
        <h1>Update Report</h1>
        <p className='text-danger'>Use Raw Values. Conversion Will Happen Automatically</p>

        {/* search bar */}
        <div className='w-100 mt-5'>
          <InputGroup
            className='mb-3 container-md w-50'
            onChange={(e) => setSearchKeyword(e.target.value)}
            onKeyDown={handleSearch}
          >
            <Form.Control
              placeholder='Enter Sample ID'
              aria-label='Enter Sample ID'
              aria-describedby='basic-addon2'
            />
            <Button
              variant='dark'
              id='button-addon2'
              className='rounded-end rounded-start-0'
              onClick={handleSearch}
              disabled={status === 'loading'}
            >
              {status === 'loading' && <Spinner size='sm' className='me-2' />}
              Search
            </Button>
          </InputGroup>
        </div>

        {/* update form  */}
        {sample.sample_id ? (
          <UpdateForm sampleDetails={sample} />
        ) : (
          <div>
            {' '}
            {error ? (
              <div className='text-danger'> {error}</div>
            ) : (
              <div> Search for sample </div>
            )}
          </div>
        )}
        <div></div>
      </div>
    </Wrapper>
  );
};

export default UpdateReport;
